import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

export default function ThinkyIOTTelemetryDataIngestion({ onBack }) {
  const initialDevices = [
    { id: 1, name: 'Device A', status: 'Online', lastActive: '2 mins ago', telemetry: Array(10).fill(0) },
    { id: 2, name: 'Device B', status: 'Online', lastActive: '15 mins ago', telemetry: Array(10).fill(0) },
    { id: 3, name: 'Device C', status: 'Offline', lastActive: '30 secs ago', telemetry: Array(10).fill(0) },
  ];

  const [devices, setDevices] = useState(initialDevices);
  const [search, setSearch] = useState('');

  // Simulate real-time telemetry updates
  useEffect(() => {
    const interval = setInterval(() => {
      setDevices(devices =>
        devices.map(d => {
          if (d.status === 'Online') {
            const newTelemetry = [...d.telemetry.slice(1), Math.floor(Math.random() * 100)];
            return { ...d, telemetry: newTelemetry, lastActive: new Date().toLocaleTimeString() };
          }
          return d;
        })
      );
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const filteredDevices = devices.filter(d => d.name.toLowerCase().includes(search.toLowerCase()));

  const generateChartData = (telemetry) => ({
    labels: Array.from({ length: telemetry.length }, (_, i) => i + 1),
    datasets: [
      {
        data: telemetry,
        borderColor: '#3b82f6',
        backgroundColor: 'rgba(59, 130, 246, 0.2)',
        tension: 0.3,
        pointRadius: 0,
      },
    ],
  });

  return (
    <div className="min-h-screen bg-black text-white px-4 py-8">
      <button onClick={onBack} className="mb-4 px-4 py-2 bg-blue-600 rounded hover:bg-blue-500 w-24">&larr; Back</button>
      <h1 className="text-lg lg:text-xl font-bold mb-4">Telemetry & Data Ingestion</h1>

      <input
        type="text"
        placeholder="Search devices..."
        className="mb-6 w-full p-2 rounded bg-neutral-900 border border-neutral-700 text-white"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {filteredDevices.map(device => (
          <div key={device.id} className="bg-neutral-900 border border-neutral-800 rounded-2xl p-5 shadow-sm">
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-lg font-semibold">{device.name}</h3>
              <span className={`px-2 py-1 rounded text-sm ${device.status === 'Online' ? 'bg-green-600' : 'bg-gray-600'}`}>{device.status}</span>
            </div>
            <p className="text-sm mb-2">Last Active: {device.lastActive}</p>
            <p className="text-sm mb-2">Current Value: <span className="font-bold text-blue-400">{device.telemetry[device.telemetry.length - 1]}</span></p>

            {device.status === 'Online' && (
              <div className="h-20 mb-3">
                <Line
                  data={generateChartData(device.telemetry)}
                  options={{
                    responsive: true,
                    plugins: { legend: { display: false } },
                    scales: { x: { display: false }, y: { display: false } },
                  }}
                />
              </div>
            )}

            <button
              onClick={() => setDevices(devices.map(d => d.id === device.id ? { ...d, telemetry: Array(10).fill(Math.floor(Math.random() * 100)) } : d))}
              className="mt-2 px-3 py-1 bg-blue-600 rounded hover:bg-blue-500 text-sm"
            >
              Simulate Event
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
